module.exports = __webpack_public_path__ + "static/media/thematic3.ab86ae28.jpg";